export const EDIT_DIGEST_HEADING = `${process.env.REACT_APP_QEWD_DIGEST_TITLE} Videos`;
export const DEFAULT_MESSAGE__HEADING = `${process.env.REACT_APP_QEWD_DIGEST_TITLE} Default Message`;
export const DEFAULT_MESSAGE__BODY = `Welcome to ${process.env.REACT_APP_QEWD_DIGEST_TITLE}. Below you will find the Top things we’ve selected for you to watch. Enjoy!`;
export const VIDEO_THUMB = 'Video Thumb';
export const VIDEO_DESC = 'Video Description';
export const TOAST_MESSAGE = `${process.env.REACT_APP_QEWD_DIGEST_TITLE} description changed successfully.`;
export const TOAST_ERROR = `Something went wrong while changing ${process.env.REACT_APP_QEWD_DIGEST_TITLE} description`;
export const EMPTY_DESC = `${process.env.REACT_APP_QEWD_DIGEST_TITLE} description cannot be empty`;
